"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _I18n = _interopRequireDefault(require("I18n"));

var _DeleteObjectPrompt = _interopRequireDefault(require("customer-data-objects-ui-components/prompt/DeleteObjectPrompt"));

function _default(onConfirm, onReject, email) {
  var title = _I18n.default.text('customerDataProperties.DeleteSecondaryEmailPrompt.emailTitle', {
    email: email
  });

  var confirmLabel = _I18n.default.text('customerDataProperties.DeleteSecondaryEmailPrompt.buttonText');

  var message = _I18n.default.text('customerDataProperties.DeleteSecondaryEmailPrompt.emailMessage');

  return (0, _DeleteObjectPrompt.default)({
    callback: onConfirm,
    onReject: onReject,
    confirmLabel: confirmLabel,
    message: message,
    title: title
  });
}

module.exports = exports.default;